import React from 'react';
import { useTranslation } from 'react-i18next';

import styles from './NoSession.module.scss';

export const NoSession = () => {
  const { t } = useTranslation(['auth']);

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>{t('auth:noSession.title')}</h1>
      <p className={styles.description}>{t('auth:noSession.description')}</p>
    </div>
  );
};
